/* eslint-disable jsx-a11y/media-has-caption */
// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

// eslint-disable-next-line no-unused-vars
function Video({ value }) {
  return (
    <iframe width="560" height="315" src="https://www.youtube.com/embed/hbG8OMzDCBU?si=bu9whViMODqZUaCs" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowfullscreen />
  );
}

Video.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Video;
